import { useContext, useEffect } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { GlobeMat, useTerrainOverlay } from 'app/agriculture/terrain/useTerrainOverlay';
import { StackBox } from 'app/agriculture/components/BoxStack/components/StackBox/StackBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { AgCheckbox } from 'app/agriculture/components/form/AgCheckbox/AgCheckbox';

interface TerrainLayerSectionProps {
    isTerrainEnabled: boolean;
}

export function TerrainLayerSection(props: TerrainLayerSectionProps) {
    const { isTerrainEnabled } = props;
    const { terrainService } = useContext(ServicesContext);
    const { globeType, setGlobalMaterial } = useTerrainOverlay();

    useEffect(() => {
        return terrainService.subscribeChangeOfTerrain(() => {
            if (!terrainService.mapTerrainEnabled) {
                setGlobalMaterial(GlobeMat.None);
            }
        });
    }, [setGlobalMaterial, terrainService]);

    const handleSlopeClick = (enable: boolean) => {
        const mat = enable ? GlobeMat.Slope : GlobeMat.None;
        setGlobalMaterial(mat);
    };

    const handleAspectClick = (enable: boolean) => {
        const mat = enable ? GlobeMat.Aspect : GlobeMat.None;
        setGlobalMaterial(mat);
    };

    return (
        <StackBox.Section
            className="TerrainLayerSection"
            id="terrain-options"
            title="Terrain options"
            defaultExpanded
        >
            <SimpleGrid className="CheckboxGroup" gap={16}>
                <AgCheckbox
                    id="terrain-layer-slope-checkbox"
                    isChecked={globeType == GlobeMat.Slope && isTerrainEnabled}
                    onChange={handleSlopeClick}
                    data-testid="TerrainLayerSectionSlopeCheckbox"
                    label="Slope"
                />
                <AgCheckbox
                    id="terrain-layer-aspect-checkbox"
                    isChecked={globeType == GlobeMat.Aspect && isTerrainEnabled}
                    onChange={handleAspectClick}
                    data-testid="TerrainLayerSectionAspectCheckbox"
                    label="Aspect"
                />
            </SimpleGrid>
        </StackBox.Section>
    );
}
